<a 
    class:shown={show}
    class="nav-link dropdown-toggle btn btn-secondary px-3 cart-dropdown"
    on:click={() => {show = !show}}
    on:keydown={(e) => { if (isNavigationInput(e)) return; show = !show;}}
    tabindex="0"
    aria-label={$_(`accessibility.cart.article-count`, [sellables.length], ["articles"])}
    aria-live="assertive"
    role="button"
    aria-haspopup="true"
>
  <i class="fas fa-shopping-cart"></i> &nbsp;<tm-article-count></tm-article-count>
</a>
{#if show}
    <div class="background-target" on:click={() => {show = false;}} />
{/if}
<div class="dropdown-menu dropdown-menu-right shadow-sm login-dropdown" class:show={show}>
  {#if sellables.length > 0}
    {#each sellables as item (item.id)}
      <div class={`cart--item cart--item--${item.type} px-4 py-2`}>
        <button class="btn-delete" on:click={((i) => () => Shop.current.cart.remove(i).catch(window.reportError))(item.id)}><i class="fas fa-times"></i></button>
  
        <tm-cart-total ids={item.id?.toString()} class="price"></tm-cart-total>
  
        {#if item.type === "permit"}
          {#if item.seat === null}
            <div class="description">{ item.event_name }</div>
          {:else}
            <div class="description">{ $_("cart.permits.seated", [item.event_name, item.seat.seat_name, item.seat.row_name, item.seat.block_name], ["event", "seat", "row", "block"]) }</div>
          {/if}
          <div class="discounts">{ Array.from(new Set([item.category_name, item.base_discount_name, ...item.discounts].filter(d => !!d))).join(", ") }</div>
          <div class="image"><tm-event-image event={item.event_id.toString()}></tm-event-image></div>
        {:else if item.type === "coupon"}
          <div class="description">{ $_("cart.coupon-description") }</div>
        {:else if item.type === "rebate"}
          <div class="description">{ item.name }</div>
        {/if}
      </div>
    {/each}
  
    <div class="dropdown-divider"></div>
    <div class="px-4 py-1 text-right">
      <table class="btn btn-sm px-3 header-cart-totals">
        {#if fees.reduce((p, {price}) => p + price, 0) > 0}
          <tr><td>{ $_("cart.headings.fees") }:</td><td class="header-cart-totals--total"><tm-cart-total kinds="fee"></tm-cart-total></td></tr>
        {/if}
        <tr><td>{ $_("cart.headings.total") }:</td><td class="header-cart-totals--total"><tm-cart-total></tm-cart-total></td></tr>
      </table>
  
      <a href={CheckoutUrl} class="btn btn-primary btn-sm px-3">
        { $_("cart.to_checkout") }&nbsp;<i class="fas fa-chevron-right"></i>
      </a>
    </div>
  {:else}
      <div class="px-4 py-2 text-center bold">
          <i class="far fa-frown tm-hint"></i> { $_('cart.empty_cart') }
      </div>
  {/if}
</div>



<style lang="less">
  .arrow-up {
      position: relative;
      z-index: 2;
      width: 0; 
      height: 0; 
      top: 8px;
      right: -50%;
      @size: 10px;
      border-left: @size solid transparent;
      border-right: @size solid transparent;
      border-bottom: @size solid var(--header-background-color);
  }

  .cart-dropdown {
      position: relative;
      z-index: 2;
  }
  .background-target {
      position: fixed;
      width: 100dvw;
      height: 100dvh;
      top: 0;
      left: 0;
      background-color: rgba(0,0,0,0.3);
  }
  .login-dropdown {
      z-index: 2;
  }
  .cart--item {
    display: grid;
    grid-template-areas:
      "image description price delete"
      "image discounts price delete";

      grid-template-columns: 50px 1fr auto;
      column-gap: .5rem;
      margin: 0;
      align-items: center;

    .description {
      grid-area: description;
      font-weight: 700;
    }

    .price {
      grid-area: price;
      text-align: right;
    }

    .discounts {
      grid-area: discounts;
    }

    .image {
      grid-area: image;
      tm-event-image {
        aspect-ratio: 1 / 1;
        width: 50px;
        height: 50px;
      }
    }

    .btn-delete {
      grid-area: delete;
      color: var(--header-text-color);
      border: 0;
      background: transparent;
    }
  }
</style>


<script lang="ts">
    import { Shop } from "@ticketmachine/sdk";
    import { _ } from "@frontend/translations";
    import { isNavigationInput } from "@/utils/html";

    import CheckoutUrl from "tm:~endpoint:{controller: 'customized/shop', action: 'check_out'}";

    let show: boolean = false;

    const rawItems = Shop.current.cart.items
    $: items = $rawItems;

    $: fees = items.filter(i => i.type === "fee");
    $: sellables = items.filter(i => i.type !== "fee");
</script>
